import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ProfileIcon from '../../../assets/img/icons/profile-icon.svg';
import { getProfileImage } from '../../../utils';
import { Button } from 'react-bootstrap';
import { QUERY_STALE_TIME, ROUTES } from '../../../constants';
import { QUERY_KEYS } from '../../../constants/queryKey';
import CircleSpinner from '../../../assets/svg/CircleSpinner';

const CSMProfileCard = ({ csmData }) => {
    const navigate = useNavigate();
    const csmName = csmData?.full_name;
    const csmImageLink = csmData?.image;

    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.USER_IMAGE, csmImageLink],
        queryFn: () => getProfileImage({ profileImg: csmImageLink }),
        placeholderData: ProfileIcon,
        enabled: !!csmImageLink,
        staleTime: QUERY_STALE_TIME.THIRTY_MIN,
    });

    /* THE BELOW CSS HAS BEEN APPLIED UNTIL WE GET A PLACEHOLDER IMAGE */
    const custom_style = csmImageLink ? {} : { border: '1px solid var(--col-br-dark)' }; // TODO

    return (
        <div className='col-12 custom-col-set w-s col-sm-2 wi' style={{ minWidth: 'max-content' }}>
            <div className='top-left ssc-shadow h-100 d-flex align-items-center justify-content-center flex-column'>
                {isFetching ? (
                    <CircleSpinner size='4.25rem' />
                ) : (
                    <img
                        className='mb-3 img-fluid csm-image-strech'
                        alt='csm_image'
                        style={custom_style}
                        src={data}
                        width={70}
                        loading='lazy'
                        height={70}
                    />
                )}

                {csmName ? (
                    <h5>
                        {csmData?.role_name === 'CSM'
                            ? 'Client Success Manager'
                            : csmData?.role_name}
                    </h5>
                ) : null}

                <h4 className=' text-center'>{csmName ? csmName : 'No CSM assigned'}</h4>
                <Button
                    type='button'
                    onClick={() =>
                        navigate(ROUTES.CUSTOMER.EDIT_PROFILE, {
                            state: {
                                editEmail: true,
                                disabledSubmitBtn: true,
                                userDetails: csmData,
                            },
                        })
                    }
                    className='ssc-secondary-white-btn w-100'
                    aria-label={`Contact ${csmData?.role_name}`}
                    title={`Contact ${csmData?.role_name}`}
                    aria-labelledby={`Contact ${csmData?.role_name}`}
                >
                    {`Contact ${csmData?.role_name}`}
                </Button>
            </div>
        </div>
    );
};

CSMProfileCard.propTypes = {
    csmName: PropTypes.string,
    csmImageLink: PropTypes.string,
};

export default CSMProfileCard;
